<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>钱包账户设置</el-breadcrumb-item>
        </el-breadcrumb>
        <br>
        <el-card>
            <el-button type="success" @click="options = 'create',showEdit = true"> + 新增钱包账户配置</el-button>
            <br>
            <el-table :data="accountInfo">
                <el-table-column prop="walletType" label="账单类型code"></el-table-column>
                <el-table-column label="转入">
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.transferIn" active-color="#13ce66" inactive-color="#ff4949"
                                   disabled></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="supportCoins" label="支持币种">
                    <template slot-scope="scope">{{scope.row.supportCoins.join(",")}}</template>
                </el-table-column>
                <el-table-column label="转出">
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.transferOut" active-color="#13ce66" inactive-color="#ff4949"
                                   disabled></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-edit" circle size="small" type="primary" @click="editInfo.supportCoins = scope.row.supportCoins,
                        editInfo.walletType = scope.row.walletType,editInfo.transferIn = scope.row.transferIn,
                        editInfo.transferOut = scope.row.transferOut,options = 'update',showEdit = true"></el-button>
                        <el-button icon="el-icon-delete" circle size="small" type="danger"
                                   @click="removeInfo(scope.row.walletType)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog title="钱包账户配置" :visible.sync="showEdit">
            <el-form ref="editForm" :model="editInfo" :rules="rules" label-width="150px">
                <el-form-item label="支持币种" prop="supportCoins">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllCoins">全选</el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group v-model="editInfo.supportCoins" @change="handleCheckedCoin">
                        <el-checkbox v-for="item in coins" :label="item" :key="item">{{item}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="账户类型" prop="walletType">
                    <el-select v-model="editInfo.walletType">
                        <el-option v-for="item in walletTypes" :key="item.code" :label="item.name"
                                   :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转入">
                    <el-switch v-model="editInfo.transferIn" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="转出">
                    <el-switch v-model="editInfo.transferOut" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitInfo()">确认提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import './store';

    export default {
        name: "walletAccount",

        data() {
            return {
                showEdit: false,
                editInfo: {walletType: '', transferIn: false, transferOut: false, supportCoins: ''},
                rules: {
                    walletType: [{required: true, message: '请选择账户类型', trigger: 'blur'}],
                    supportCoins: [{required: true, message: '请输入支持币种', trigger: 'blur'}],
                },
                walletTypes: [
                    {name: '我的钱包', code: 'WALLET'},
                    //{name: '交易账户', code: 'SPOT'},
                    {name: '杠杆账户', code: 'MARGIN'},
                    {name: '法币账户', code: 'OTC'},
                    {name: '合约账户', code: 'CONTRACT'},
                    {name: '超级合约账户', code: 'GENERAL'},
                    //{name: '理财账户', code: 'FINANCIAL'},
                ],
                options: 'create',//update
                isIndeterminate: true,
                checkAll: false,
            }
        },

        computed: {
            ...mapState('walletAccount', ['accountInfo','coins'])
        },

        methods: {
            ...mapActions('walletAccount', ['getWalletAccountList', 'removeWalletAccountConfig', 'alterWalletAccount', 'insertWalletAccount','getAllSuppCoin']),

            /**提交创建或更新配置*/
            submitInfo() {
                if (this.options === 'create') {
                    this.insertWalletAccount(this.editInfo).then(() => {
                        this.$message({type: 'success', message: '新增成功'});
                        this.clearForm();
                    })
                }
                if (this.options === 'update') {
                    this.alterWalletAccount(this.editInfo).then(() => {
                        this.$message({type: 'success', message: '修改成功'});
                        this.clearForm();
                    })
                }
            },

            /**删除配置*/
            removeInfo(walletType) {
                this.$confirm('确认删除该配置?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'})
                    .then(() => {
                        this.removeWalletAccountConfig({walletType: walletType}).then(() => {
                            this.getWalletAccountList();
                            this.$message({type: 'success', message: '删除成功'});
                        })
                    }).catch(() => {
                    this.$message({type: 'info', message: '已取消删除'});
                })
            },

            /**清空表单数据*/
            clearForm() {
                this.$refs['editForm'].resetFields();
                this.showEdit = false;
                this.isIndeterminate = false;
                this.checkAll = false;
                this.getWalletAccountList();
            },

            /**选择所有币种*/
            handleCheckAllCoins(val){
                this.editInfo.supportCoins = val ? this.coins : [];
                this.isIndeterminate = false;
            },

            /**选择部分支持币种*/
            handleCheckedCoin(val) {
                let len = val.length;
                this.checkAll = len === this.coins.length;
                this.isIndeterminate = len > 0 && len < this.coins.length;
            },

        },

        created() {
            this.getWalletAccountList();
            this.getAllSuppCoin();
        }
    }
</script>

<style scoped>

</style>
